export default "__VITE_ASSET__F3PCBcMJ__"